document.addEventListener('DOMContentLoaded', () => {
   const btn = document.querySelector('.js-categories-toggle');
   const dropdown = document.querySelector('.js-categories-dropdown');

   if (!btn || !dropdown) return;

   btn.addEventListener('click', () => {
      dropdown.classList.toggle('is-active');
   });

   document.addEventListener('click', (e) => {
      if (!btn.contains(e.target) && !dropdown.contains(e.target)) {
         dropdown.classList.remove('is-active');
      }
   });
});